import { Http } from 'sparnord-utils'

export default class Cases extends Http.AbstractModel {
  static get _id () {
    return '283f26b7-a05d-4901-86d1-c0b865402123'
  }

  static get endpoint () {
    return `/${Cases._id}/children?size=9999`
  }

  get body () {
    return this.item.properties.dstCaseBody
  }

  get city () {
    return this.item.properties.dstCaseCity
  }

  get title () {
    return this.item.properties.dstCaseTitle
  }

  get thumbnail () {
    return `${Http.AbstractModel.root}${this.item.properties.dstCaseThumbnail.url}`
  }

  get video () {
    return this.item.properties.dstCaseVideoUrl
  }
}



// WEBPACK FOOTER //
// ./src/models/cases.js